module.exports = __webpack_public_path__ + "static/media/custom-agent.7fa116d4.jpg";